<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <NuxtLink
    :to="link"
    class="breadcrumb__btn btn btn-link d-flex align-items-center p-0"
    data-testid="breadcrumb"
  >
    <ChevronLeftIcon height="12.8px" width="6.93px" fill="#000" />
    <span class="breadcrumb__text ml-8">
      {{ text }}
    </span>
  </NuxtLink>
</template>

<script>
import ChevronLeftIcon from '~/assets/icons/chevron-left.svg'

export default {
  components: {
    ChevronLeftIcon
  },
  props: {
    link: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb__btn {
  min-height: 24px;
  margin-left: 4px;
  white-space: normal;
  text-align: left;
}

.breadcrumb__text {
  color: $black;
  font-size: 16px;
}
</style>
